function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17.002 8.999V6.998h-2",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 9.285l1.286-1.287L14.001 10l3.001-3.001M14.001 13.5h3.001M14.001 16.502h3.001M2.997 13.6v6.804c0 .883 1.791 1.6 4.001 1.6 2.21 0 4-.717 4.002-1.6V13.6",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.999 13.6c0 .885-1.792 1.601-4.002 1.601s-4-.716-4-1.6c0-.885 1.792-1.601 4.001-1.601 2.21 0 4 .717 4.002 1.6M2.997 17.002c0 .884 1.79 1.6 4 1.6S11 17.887 11 17.003",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.997 8.999V4.997a2 2 0 012-2h12.006a2 2 0 012 2v13.006a2 2 0 01-2 2H14",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));